import React, { useEffect, useRef, useState } from "react";
import { getEnvUrl, getToken } from "../../../utils/Api";
import Loader from "../../common/loader";
import { toast } from 'react-toastify';
import CreateUser from "./popups/createUser";
import ViewUser from "./popups/viewUser";
import { deleteOfflineUserByID } from "../../../Services/User/User";
import { checkPermissions } from "../../../Services/User/User";
import { useNavigate, useParams } from "react-router-dom";
import './offlineUsersList.css';

const $ = require("jquery");
require("datatables.net");
const OfflineUsersList = ({ data }) => {
  const tableRef = useRef(null);
  const [isLoading, setIsLoading] = useState(true);
  const [createUserModal, setCreateUserModal] = useState(false);
  const [editUserModal, setEditUserModal] = useState(false);
  const [rerender, setRetender] = useState(true);
  const [viewUserID, setViewUserID] = useState(false);
  const navigate = useNavigate();
  const { projectId } = useParams();
  const [viewSystemUserModal, setViewSystemUserModal] = useState(false);
  const viewSystemUserModalClose = () => { setViewSystemUserModal(false) }
  const createUserModalClose = (rr = true) => {
    setCreateUserModal(false)
    if (rr) {
      setRetender(!rerender)
    }
  }
  const editUserModalClose = (rr = true) => {
    setEditUserModal(false)
    if (rr) {
      setRetender(!rerender)
    }
  }
  const [editUserId, setEditId] = useState(false);

  // useEffect(() => {
  // if(!checkPermissions('users_list_page') || !checkPermissions('users_navigation')){ 
  //     navigate('/')
  //   }
  // },[])
  useEffect(() => {
    // Initialize DataTable
    const table = $(tableRef.current).DataTable({
      processing: true,
      serverSide: true,
      serverMethod: "get",
      ajax: {
        url: `${getEnvUrl()}/admin/user/offlineUserReport`,
        data: { from_date: '', to_date: '', project_id: projectId || '' },
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      },
      columns: [
        { data: "id" },
        { data: "userName" },
        {
          data: "schoolName",
          className: "wrap-text school-name"
        },
        {
          data: "city",
        },
        {
          data: "village",
        },
        {
          data: "apkType"
        },
        {
          data: "active",
          render: (active) =>
            active === true || active === "true" ? "Active" : "In-Active"
        },
        // { data: "created_on" },
        {
          data: null,
          title: 'Actions',
          render: (data, type, row) => (
            `<div> 
              <span class="a-edit"><i class="bi bi-pencil-square"></i></span>
              <span class="a-view"><i class="bi bi-eye-fill"></i></span>
          </div>`
          )
        },
      ],
      createdRow: (row, data, dataIndex) => {
        $(row).find('.a-edit').on('click', () => {
          setEditUserModal(true)
          setEditId(data.id)
        });
        $(row).find('.a-view').on('click', () => {
          setViewSystemUserModal(true)
          setViewUserID(data.id)
        });
        $(row).find('.a-delete').on('click', () => {
          if (window.confirm('Are you sure you want to de-activate this user?')) {
            deleteOfflineUserByID(data.id)
              .then((response) => {
                if (response.status === true) {
                  toast.success(response.message)
                  setRetender(!rerender)
                } else {
                  toast.error(response.errorMessage)
                }
              })
              .catch((error) => {
                toast.error('Error deleting user:', error);
              });
          }
        });
      },
      'columnDefs': [{
        'targets': [7], /* column index */
        'orderable': false, /* true or false */
      }],
      drawCallback: function (settings) {
        setIsLoading(false);
        tableRef.current?.style.setProperty("width", "100%", "important");
      },
      aaSorting: [[0, "desc"]]
    });

    return () => {
      // Destroy DataTable when component unmounts to avoid memory leaks
      table.destroy();
    };
  }, [data, rerender, projectId]);


  return (
    <div>
      <main id="main" className="main">
        <div className="pagetitle">
          <h1>Offline Users List</h1>
        </div>
        <section className="section">
          <div className="row">
            <div className="col-lg-12">
              <div className="card p-10">
                {checkPermissions('user_create') &&
                  <div className="col-sm-2 mb-2">
                    <button type="button" className="btn btn-primary"
                      onClick={() => setCreateUserModal(true)} >Add Offline User</button>
                  </div>
                }
                {isLoading ? <Loader /> : ""}
                <div className={isLoading ? 'card-body hide' : 'card-body'}>
                  <table
                    className="table table-striped table-hover table-bordered no-footer dataTable"
                    width="100%"
                    ref={tableRef}
                  >
                    <thead>
                      <tr>
                        <th>User ID</th>
                        <th>User Name</th>
                        <th>AWC Name</th>
                        <th>SEC Name</th>
                        <th>Mandal Name</th>
                        <th>APK Type</th>
                        <th>Active</th>
                        {/* <th>CreatedOn</th> */}
                        <th>Action</th>
                      </tr>
                    </thead>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      {createUserModal ? <CreateUser isShow={createUserModal} close={createUserModalClose} projectId={projectId} type="CREATE" /> : ''}
      {editUserModal ? <CreateUser isShow={editUserModal} close={editUserModalClose} projectId={projectId} userId={editUserId} type="EDIT" /> : ''}
      {viewSystemUserModal ? <ViewUser isShow={viewSystemUserModal} close={viewSystemUserModalClose} editUserId={viewUserID} /> : ''}

    </div>
  );
};
export default OfflineUsersList;

